import styled from "styled-components";
import farmer from "../../Assets/farmer.webp";

export const LoginContainer = styled.form`
  display: grid;
  grid-template-columns: 1fr 1fr;
  height: 100vh;

  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const LoginForm = styled.form`
  display: flex;
  flex-direction: column;
  width: 50%;
  margin: auto;
  h1 {
    font-size: 3.2rem;
  }

  span {
    color: #3cc830;
    font-weight: bold;
  }

  label {
    font-size: 1.6rem;
    margin-top: 1.5rem;

    :not(:first-of-type) {
      margin-top: 2rem;
    }
  }

  input {
    margin: 0.5rem 0;
    padding: 1rem;
    border-radius: 0.5rem;
    border: 1px solid #3cc830;
    outline: none;
  }

  button {
    margin: 1rem 0;
    padding: 1rem;
    border-radius: 0.5rem;
    border: none;
    outline: none;
    background: #3cc830;
    color: #fff;
    font-size: 1.6rem;
    font-weight: bold;
    cursor: pointer;

    :hover {
      background: #005900;
    }
  }

  div {
    font-size: 1.6rem;
    margin-top: 1rem;
  }
`;

export const Image = styled.div`
  background-image: url(${farmer});
  width: 100%;
  height: 100%;
  object-fit: contain;
  background-size: cover;
  backgorund-position: center;

  @media screen and (max-width: 768px) {
    display: none;
  }
`;
